import styled from 'styled-components'

export const DebugBarContainer = styled.div`
  font-family: monospace;
  position: absolute;
  width: 100%;
  height: 100px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  z-index: 999;
`

export const DebugBarDialog = styled.div`
  width: 100%;
  padding: 20px;
`
export const DebugBarContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  p {
    margin: 0;
  }
`
